"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashReceiptSchema = void 0;
var cash_receipt_type_code_1 = require("./cash-receipt-type-code");
exports.cashReceiptSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    anyOf: [
        { required: ['typeCode', 'indexNumber', 'receivedAmount', 'receivedDate'] },
        { required: ['typeCode', 'indexNumber', 'previouslyApprovedAmount', 'previouslyApprovedDate'] },
    ],
    properties: {
        typeCode: {
            type: 'string',
            enum: Object.values(cash_receipt_type_code_1.CashReceiptTypeCode),
            errorMessage: 'Should equate to a valid CashReceiptTypeCode Enum value',
        },
        admissibleAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        admissibleDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be a string with maximum length of 1000 characters or null',
        },
        indexNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 100,
            errorMessage: 'Should be an integer between 0 and 100',
        },
        partialPaymentAppliedToInterestAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        partialPaymentAppliedToPrincipalAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        partialPaymentAppliedToTaxAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        previouslyApprovedAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        previouslyApprovedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        receivedAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        receivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
    },
};
